





















import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement } from 'chart.js';
import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DashboardModule } from '@/store/Dashboard/DashboardModule';

ChartJS.register(Title, Tooltip, Legend, LineElement, LinearScale, CategoryScale, PointElement);

@Component({ name: 'AccountsChart', components: { LineChartGenerator } })
export default class extends SaascadaVue {

    // Translated names for months
    monthNames = [
        this.$t('pageText.dashboard.fields.jan'),
        this.$t('pageText.dashboard.fields.feb'),
        this.$t('pageText.dashboard.fields.mar'),
        this.$t('pageText.dashboard.fields.apr'),
        this.$t('pageText.dashboard.fields.may'),
        this.$t('pageText.dashboard.fields.june'),
        this.$t('pageText.dashboard.fields.july'),
        this.$t('pageText.dashboard.fields.aug'),
        this.$t('pageText.dashboard.fields.sept'),
        this.$t('pageText.dashboard.fields.oct'),
        this.$t('pageText.dashboard.fields.nov'),
        this.$t('pageText.dashboard.fields.dec')
    ];

    getPreviousMonthName(index: number) {
        // Returns a name string where index 0 is the current month, 1 is the previous month, etc.
        const today = new Date();
        const date = new Date(today.getFullYear(), today.getMonth() - index, 1);
        const monthName = this.monthNames[date.getMonth()];
        return monthName;
    }

    get chartData() {
        return {
            labels: [
                // Last 7 months including the current month
                this.getPreviousMonthName(6),
                this.getPreviousMonthName(5),
                this.getPreviousMonthName(4),
                this.getPreviousMonthName(3),
                this.getPreviousMonthName(2),
                this.getPreviousMonthName(1),
                this.getPreviousMonthName(0)
            ],
            datasets: [{
                    label: this.$t('pageText.dashboard.titles.accountsChart'),
                    backgroundColor: this.$vuetify.theme.currentTheme.secondary,
                    data: [160, 179, 1120, 1150, 1215, 1300, 1668]
            }],
        };
    }

    get chartOptions() {
        return {
            plugins: {
                legend: {
                    display: false
                },
            },
            responsive: true,
            maintainAspectRatio: false
        };
    }

    get styles() {
        return {
            height: "300px",
            position: "relative"
        };
    }

}
